import { createContext } from 'react';

import type { Runtime } from './runtime';

export type RuntimeContextType = {
  runtime: Runtime;
};

export const RuntimeContext = createContext<RuntimeContextType | undefined>(
  undefined
);
RuntimeContext.displayName = 'RuntimeContext';

export const RuntimeProvider: React.FC<
  React.PropsWithChildren<RuntimeContextType>
> = ({ children, runtime }) => {
  return (
    <RuntimeContext.Provider value={{ runtime }}>
      {children}
    </RuntimeContext.Provider>
  );
};
